import { render, staticRenderFns } from "./OrderConfirmationsPopup.vue?vue&type=template&id=00e841f2&"
import script from "./OrderConfirmationsPopup.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports